<template>
  <span :class="paramClass">{{ humanParam }}</span>
</template>

<script>
export default {
  name: 'ApiDocParamInfo',
  props: {
    param: {
      type: String,
      required: true,
    },
  },
  computed: {
    paramClass() {
      if (this.param === 'required') {
        return 'text-danger';
      }
      if (this.param.indexOf('required_if:') === 0) {
        return 'text-danger';
      }
      return '';
    },
    humanParam() {
      if (this.param === 'required') {
        return 'обязательное';
      }
      if (this.param === 'nullable') {
        return 'не обязательное';
      }

      if (this.param === 'string') {
        return 'строка';
      }

      if (this.param === 'phone') {
        return 'телефон';
      }

      if (this.param === 'required') {
        return 'обязательное';
      }

      if (this.param.indexOf('in:') === 0) {
        return this.param.replace('in:', 'только:');
      }

      if (this.param.indexOf('required_if:') === 0) {
        return this.param.replace('required_if:', 'обязательное если:');
      }

      return this.param;
    },
  },
};
</script>
